import React, { useEffect, useState } from 'react';
import * as Styled from './Certifications.style';
import { parseISO, format } from 'date-fns';
import PropTypes from 'prop-types';

import CertificationModal from './CertificationModal';

import { translate as t } from '@utils/translate';
import { getExpirationTimeString } from '../../utils/certifications.helper';

const Certifications = ({
  certifications,
  governmentOnly,
  onClickDetails,
  onCloseDetails,
}) => {
  const [validCertifications, setValidCertifications] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const TEXTS = {
    FIRST_CERTIFICATION: t('firstCertification'),
    AIR_CARRIER_CERTIFICATE: t('airCarrierCertificate'),
  };

  useEffect(() => {
    let filteredCertifications = [];
    if (certifications) {
      if (governmentOnly) {
        filteredCertifications = certifications.filter(
          certification => certification.certification.category === 'government'
        );
        setValidCertifications([...filteredCertifications]);
      } else setValidCertifications([...certifications]);
    }
  }, [certifications]);

  const handleModalOpen = active => {
    setOpenModal(active);
    if (active && onClickDetails) onClickDetails();
    else if (!active && onCloseDetails) onCloseDetails();
  };

  const renderCerts = certification => {
    const firstCertificated = certification.firstCertificatedAt
      ? format(parseISO(certification.firstCertificatedAt), 'yyyy')
      : '';

    return (
      <>
        <Styled.CardCertification>
          <Styled.Image src={certification.certification.iconImageUrl} />
          <Styled.SeeDetails onClick={() => handleModalOpen(true)}>
            <strong>{TEXTS.AIR_CARRIER_CERTIFICATE}</strong>
          </Styled.SeeDetails>
          <Styled.CardCertificationInformation>
            <Styled.CardCertificationName>
              {certification.certification.name}
              {certification.certification.isLive === 1 ? (
                <Styled.CertificationStatus>Live</Styled.CertificationStatus>
              ) : (
                ''
              )}
            </Styled.CardCertificationName>

            <Styled.CertificationExpires>
              {getExpirationTimeString(certification.expirationDate)}
            </Styled.CertificationExpires>

            <Styled.CertificationDate>
              {TEXTS.FIRST_CERTIFICATION} {firstCertificated}
            </Styled.CertificationDate>
          </Styled.CardCertificationInformation>
        </Styled.CardCertification>
        {openModal && (
          <CertificationModal
            certifications={certifications}
            closeModal={() => handleModalOpen(false)}
          />
        )}
      </>
    );
  };

  return validCertifications.length > 0 && renderCerts(validCertifications[0]);
};

Certifications.propTypes = {
  certifications: PropTypes.array,
  governmentOnly: PropTypes.bool,
  onClickDetails: PropTypes.func,
  onCloseDetails: PropTypes.func,
};

export default Certifications;
